export default class CommunityFeedback {
  constructor(shedCode, fuelType, userID, timeFeedbackUT, pollOptionID) {
    this.shedCode = shedCode;
    this.fuelType = fuelType;
    this.userID = userID;
    this.timeFeedbackUT = timeFeedbackUT;
    this.pollOptionID = pollOptionID;
  }
}
